import {systemInfo} from "@/systemInfo.js";

export const setState = (state) => {
    if (state === systemInfo.state.current) return

    systemInfo.state.last = systemInfo.state.current
    systemInfo.state.current = state
    console.log(`[STATE] Set to ${getCurrentState()}`)

    window.dispatchEvent(new CustomEvent('state-changed', {
        detail: {state: state}
    }));
}

export const getCurrentState = () => {
    return systemInfo.state.current
}

export const getLastState = () => {
    return systemInfo.state.last
}